import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";

export interface AutosizeInputRef {
    focus: () => void;
}

interface AutosizeInputProps {
    id?: string;
    name?: string;
    value?: string;
    initFocus?: boolean;
    onChange?: (value: string) => void;
    className?: string;
}

const AutosizeInput = forwardRef<AutosizeInputRef, AutosizeInputProps>
(
    ({id, name, value, onChange, initFocus = true, className}, ref) => {
        const isControlled = value !== undefined;

        const [innerValue, setInnerValue] = useState("");

        const inputRef = useRef<HTMLInputElement | null>(null);

        useImperativeHandle(ref, () => ({
            focus() {
                inputRef.current?.focus();
            }
        }));

        useEffect(() => {
            if (initFocus) inputRef.current?.focus();
        }, [initFocus]);

        const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const nextValue = e.target.value;

            if (onChange) onChange(nextValue);

            if (!isControlled) {
                setInnerValue(nextValue);
            }
        };

        const shownValue = (isControlled ? value : innerValue) || " ";

        return (
            <div className={`position-relative ${className ?? ""}`} style={{width: 'min-content', minWidth: '1em'}}>
            <span className="p-0"
                  style={{
                      fontFamily: "Arial",
                      fontSize: "1em",
                      visibility: "hidden",
                      whiteSpace: "pre"
                  }}>{shownValue}</span>
                <input ref={inputRef} id={id} name={name} className="position-absolute w-100 lh-1"
                       value={value}
                       style={{
                           fontFamily: "Arial",
                           fontSize: "1em",
                           boxSizing: "content-box",
                           left: "0",
                           padding: "0 2px 0 1px"
                       }}
                       type="text" onChange={handleInputChange}/>
            </div>
        );
    }
);

AutosizeInput.displayName = "AutosizeInput";

export default AutosizeInput;